var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFromTheOldest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 20H10C10.55 20 11 19.55 11 19C11 18.45 10.55 18 10 18H3C2.45 18 2 18.45 2 19C2 19.55 2.45 20 3 20ZM6 13H10C10.55 13 11 12.55 11 12C11 11.45 10.55 11 10 11H6C5.45 11 5 11.45 5 12C5 12.55 5.45 13 6 13ZM10 6H8C7.45 6 7 5.55 7 5C7 4.45 7.45 4 8 4H10C10.55 4 11 4.45 11 5C11 5.55 10.55 6 10 6ZM19.0002 7.3562L20.3052 8.6162C20.7032 8.9992 21.3362 8.9872 21.7192 8.5912C22.1032 8.1932 22.0922 7.5602 21.6952 7.1772L18.6952 4.2802C18.5002 4.0942 18.2502 4.0002 18.0002 4.0002C17.7442 4.0002 17.4882 4.0972 17.2932 4.2932L14.2932 7.2932C13.9022 7.6832 13.9022 8.3162 14.2932 8.7072C14.6832 9.0972 15.3162 9.0972 15.7072 8.7072L17.0002 7.4142V16.6432L15.6952 15.3842C15.2972 14.9992 14.6652 15.0122 14.2812 15.4092C13.8972 15.8062 13.9082 16.4392 14.3052 16.8232L17.3052 19.7202C17.6982 20.0952 18.3222 20.0932 18.7072 19.7072L21.7072 16.7072C22.0972 16.3162 22.0972 15.6832 21.7072 15.2932C21.5122 15.0972 21.2562 15.0002 21.0002 15.0002C20.7442 15.0002 20.4882 15.0972 20.2932 15.2932L19.0002 16.5862V7.3562Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromTheOldest);
export default __webpack_public_path__ + "static/media/FromTheOldest.40d38e1811306758e4c68c65f1286222.svg";
export { ForwardRef as ReactComponent };